import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "overline" }

import {
    IonContent,
    IonFooter,
    IonHeader,
    IonIcon,
    IonItem,
    IonLabel,
    IonList,
    IonMenu,
    IonMenuToggle,
    IonNote,
    IonSelect,
    IonSelectOption,
    IonTitle,
    IonToolbar,
    alertController,
    SelectCustomEvent
  } from "@ionic/vue";
  import { computed } from "vue";
  import { useStore } from "@/store";
  import { useRouter } from "vue-router";
  import { cloudUploadOutline, globeOutline, settingsOutline, sendOutline, storefrontOutline, pulseOutline } from 'ionicons/icons';
  import { translate } from "@hotwax/dxp-components";
  import emitter from "@/event-bus";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Menu',
  setup(__props) {

  const store = useStore();
  const router = useRouter();
  const appPages = [
        {
          title: "Threshold",
          url: "/threshold",
          childRoutes: ["/create-threshold", "/update-threshold/"],
          iosIcon: globeOutline,
          mdIcon: globeOutline
        },
        {
          title: "Safety stock",
          url: "/safety-stock",
          childRoutes: ["/create-safety-stock", "/update-safety-stock/"],
          iosIcon: pulseOutline,
          mdIcon: pulseOutline
        },
        {
          title: "Store pickup",
          url: "/store-pickup",
          childRoutes: ["/create-store-pickup", "update-store-pickup/"],
          iosIcon: storefrontOutline,
          mdIcon: storefrontOutline
        },
        {
          title: "Shipping",
          url: "/shipping",
          childRoutes: ["/create-shipping", "/update-shipping/"],
          iosIcon: sendOutline,
          mdIcon: sendOutline
        },
        {
          title: "Inventory channels",
          url: "/inventory-channels",
          iosIcon: cloudUploadOutline,
          mdIcon: cloudUploadOutline
        },
        {
          title: "Settings",
          url: "/settings",
          iosIcon: settingsOutline,
          mdIcon: settingsOutline
        }
      ];

  const userProfile = computed(() => store.getters["user/getUserProfile"])
  const isUserAuthenticated = computed(() => store.getters["user/isUserAuthenticated"])
  const eComStore = computed(() => store.getters["user/getCurrentEComStore"])
  const instanceUrl = computed(() => store.getters["user/getInstanceUrl"])
  const selectedIndex = computed(() => {
    const path = router.currentRoute.value.path;
    return appPages.findIndex((screen) => screen.url === path || screen.childRoutes?.includes(path) || screen.childRoutes?.some((route) => path.includes(route)));
  });

  async function setEComStore(event: SelectCustomEvent) {
    const createUpdateRoute = ["/create-threshold", "/update-threshold/", "/create-safety-stock", "/update-safety-stock/", "/create-store-pickup", "update-store-pickup/", "/create-shipping", "/update-shipping/"]
    const path = router.currentRoute.value.path;
    if(userProfile.value?.stores) {
      if(createUpdateRoute.some((route) => path.includes(route))) {
        const alert = await alertController.create({
          header: translate("Leave page"),
          message: translate("Any page made on this page will be lost. You will not be able to reverse this action."),
          buttons: [
            {
              text: translate("No"),
              role: "cancel",
              handler: async () => {
                // Reverting the selected ecomStore in ion-select if user select no to change product store.
                event.target.value = eComStore.value.productStoreId
              }
            },
            {
              text: translate("Yes"),
              handler: async () => {
                await store.dispatch("user/setEcomStore", {
                  "productStoreId": event.detail.value
                })
                emitter.emit("productStoreOrConfigChanged")
              }
            }
          ]
        })

        alert.present();
      } else {
        store.dispatch("user/setEcomStore", {
          "productStoreId": event.detail.value
        })
        emitter.emit("productStoreOrConfigChanged")
      }
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonMenu), {
    "content-id": "main",
    type: "overlay",
    disabled: !isUserAuthenticated.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)("Available to Promise")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonList), null, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appPages, (page, index) => {
                return _createVNode(_unref(IonMenuToggle), {
                  "auto-hide": "false",
                  key: index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(IonItem), {
                      button: "",
                      "router-direction": "root",
                      "router-link": page.url,
                      class: _normalizeClass(["hydrated", { selected: selectedIndex.value === index}])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonIcon), {
                          slot: "start",
                          ios: page.iosIcon,
                          md: page.mdIcon
                        }, null, 8, ["ios", "md"]),
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(page.title), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["router-link", "class"])
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonFooter), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonItem), { lines: "none" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", _hoisted_1, _toDisplayString(instanceUrl.value), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(IonNote), { slot: "end" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(userProfile.value?.timeZone), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (userProfile.value?.stores?.length > 1)
                ? (_openBlock(), _createBlock(_unref(IonItem), {
                    key: 0,
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonSelect), {
                        interface: "popover",
                        value: eComStore.value.productStoreId,
                        onIonChange: _cache[0] || (_cache[0] = ($event: any) => (setEComStore($event)))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((userProfile.value?.stores ? userProfile.value.stores : []), (store) => {
                            return (_openBlock(), _createBlock(_unref(IonSelectOption), {
                              key: store.productStoreId,
                              value: store.productStoreId
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(store.storeName ? store.storeName : store.productStoreId), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_unref(IonItem), {
                    key: 1,
                    lines: "none"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonLabel), { class: "ion-text-wrap" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(eComStore.value.storeName ? eComStore.value.storeName : eComStore.value.productStoreId), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})